import { render, staticRenderFns } from "./list-share-settings.vue?vue&type=template&id=50f6e5ba&scoped=true&"
import script from "./list-share-settings.vue?vue&type=script&lang=ts&"
export * from "./list-share-settings.vue?vue&type=script&lang=ts&"
import style0 from "./list-share-settings.vue?vue&type=style&index=0&id=50f6e5ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f6e5ba",
  null
  
)

export default component.exports